import React, { createContext, useContext, useState } from 'react';

export const ModalContext = createContext({} as any);

export const useModal = () => useContext(ModalContext);

interface Props {
    children: React.ReactNode;
}

export const ModalProvider = ({ children }: Props) => {
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [onConfirm, setOnConfirm] = useState(() => () => {});
    const [message, setMessage] = useState('Do you wish to continue with this action')

    const toggleConfirmationModal = (confirmAction = null, message = '') => {
        if(message.length > 0) {
            setMessage('')
            setMessage(message)
        }

        if(!showConfirmationModal) setMessage(message)

        if (confirmAction) {
            setOnConfirm(() => confirmAction);
        } else {
            setOnConfirm(() => () => {});
        }
        setShowConfirmationModal(!showConfirmationModal);
    }

    return (
        <ModalContext.Provider value={{ showConfirmationModal, onConfirm, message, setShowConfirmationModal: toggleConfirmationModal }}>
            {children}
        </ModalContext.Provider>
    );
};